import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Tabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Define tabs configuration here
    const tabs = ['predictions', 'leaderboards'];
    const tabNames = {
        leaderboards: 'Leaderboard',
        predictions: 'predictions',
    };
    const tabRoutes = {
        leaderboards: '/evaluation',
        predictions: '/prediction',
    };

    // Determine active tab based on current route
    const getActiveTab = () => {
        const currentPath = location.pathname;
        if (currentPath.startsWith('/evaluation')) return 'leaderboards';
        if (currentPath.startsWith('/prediction')) return 'predictions';
        return tabs[0];
    };

    const activeTab = getActiveTab();

    const handleTabClick = (tab) => {
        navigate(tabRoutes[tab]);
    };

    return (
        <div>
            <div className="prediction-tabs" role="tablist">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        role="tab"
                        aria-selected={tab === activeTab}
                        className={tab === activeTab ? 'prediction-tab active' : 'prediction-tab inactive'}
                        onClick={() => handleTabClick(tab)}
                    >
                        {tabNames[tab]}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Tabs;